import { render, staticRenderFns } from "./AsideMenuBar.vue?vue&type=template&id=0f3d21af"
import script from "./AsideMenuBar.vue?vue&type=script&lang=js"
export * from "./AsideMenuBar.vue?vue&type=script&lang=js"
import style0 from "./AsideMenuBar.vue?vue&type=style&index=0&id=0f3d21af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports